import React, { createContext, useContext, useEffect } from 'react';
import { useAsync } from 'react-use';
import URI from 'urijs';
import fetch from 'isomorphic-fetch';
import cx from 'classnames';
import { BlogPost } from './post';

// modules
import BS from '../../theme/Bootstrap';
import BlogStyles from './Blog.module.scss';

export const BlogContext = createContext();

const URL = `${process.env.REACT_APP_REST_URI}/blog`;

/**
 * A number, or a string containing a number.
 * @typedef {import('@tryghost/content-api').PostOrPage} Post
 */

/**
 * @typedef {object} BlogListProps
 * @property {string} [id] ignores the other search props and fetches by id
 * @property {string} [slug] ignores the other search props and fetches by slug
 * @property {string} [search] search title and content of posts
 * @property {string|string[]} [tags] search by exact tag slugs
 * @property {boolean} [featured] featured only
 * @property {number} [page]
 * @property {number} [limit]
 */

/**
 *
 * @param {BlogListProps} props
 * @returns {React.ReactElement}
 */
export function BlogList(props) {
  const { id, slug, search, tags, featured, page, limit } = props;
  const context = useContext(BlogContext);
  const state = useAsync(async () => {
    return fetch(
      URI(URL)
        .search({
          id,
          slug,
          search,
          tags: [].concat(tags || []).join(','),
          featured: featured ? '1' : undefined,
          page,
          limit
        })
        .toString(),
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    )
      .then(response => response.json())
      .then(response => [].concat(response || []));
  }, [id, search, tags, featured, page, limit]);
  const posts = state.value || [];

  useEffect(() => {
    if (context && context.setResults) {
      context.setResults(state.value);
    }
  }, [state.value]);

  const isList = !id && !slug;

  return (
    <div className={cx(BlogStyles.Blog, isList && BlogStyles.BlogList)}>
      {state.loading && <div className={BS.textCenter}>...Loading</div>}
      {!state.loading &&
        posts.map(post => {
          return <BlogPost key={post.id} record={post} inList={isList} />;
        })}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/blog/list.js